<template>
  <div class="h5-problem-page">
    <div v-infinite-scroll="handleInfiniteOnLoad" class="demo-infinite-container" :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10">
      <a-list :data-source="data">
        <a-list-item slot="renderItem" slot-scope="item">
          <div class="problem-list" @click="btnGoDetails(item)">
            <div class="problem-list-title">
              <span>{{ item.title }}</span>
            </div>
            <div class="problem-list-content">
              <span>{{ item.content }}</span>
            </div>
          </div>
        </a-list-item>
        <!-- <div v-if="loading && !busy" class="demo-loading-container">
          <a-spin />
        </div> -->
      </a-list>
    </div>
  </div>
</template>
<script>
import reqwest from "reqwest";
import infiniteScroll from "vue-infinite-scroll";
import { problempost } from "@/utils/api";
export default {
  data() {
    return {
      keywords: "",
      pageNo: 1,
      pageSize: 8,
      data: [],
      loading: false,
      busy: false,
      total: null,
      token:""
    };
  },
  directives: {
    infiniteScroll,
  },
  mounted() {
    window["getProblemData"] = (keywords,token) => {
        this.getProblemData(keywords,token);
    };
  },
  methods: {
    btnGoDetails(item) {
      this.$router.push("/h5/problemDetails?id="+item.id+"&token="+this.token);
    },
    getProblemData(keywords,token){
        this.token = token
        this.keywords = keywords
        this.getProblemList();
    },
    handleInfiniteOnLoad() {
      const data = this.data;
      this.loading = true;
      if (data.length > this.total) {
        this.busy = true;
        this.loading = false;
        return;
      } else {
        this.pageNo += 1;
        this.getProblemList();
      }
    },
    getProblemList() {
      let url = "/system/api/helpCenter/pageListHelpCenterByCategoryId";
      let params = {};
      let header = {
        Authorization: 'Bearer '+this.token,
      };
      let data = {
        keywords: this.keywords,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      problempost(url, params, header, data).then((res) => {
        if (res.code == 200) {
          this.total = res.result.total;
          if(res.result.records.length>0) {
            res.result.records.map((item) => {
                this.data.push(item);
            });
          }
          this.loading = false;
        } else {
        }
      });
    },
  },
};
</script>
<style lang="scss">
.h5-problem-page {
  min-height: 100%;
  background-color: #ffffff;
  padding: 0 24px;
  .problem-list {
    padding: 15px 24px;
    // border-bottom: 1px solid #aaaaaa;
    .problem-list-title {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }
    .problem-list-content {
      font-size: 16px;
      color: #333333;
      margin-top: 12px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
}
</style>
